export const accTabListOverflowCountSingular = "w6dPgb";
export const accTabListOverflowCountFirstPlural = "r86zde";
export const accTabListOverflowCountSecondGenitivePlural = "aO69e";
export const accTabListOverflowTabTitle = "$d6idc";
export default {accTabListOverflowCountSingular,accTabListOverflowCountFirstPlural,accTabListOverflowCountSecondGenitivePlural,accTabListOverflowTabTitle};